"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_EVENT = void 0;
exports["default"] = sendEvent;
var SEND_EVENT = 'WEB_CHAT/SEND_EVENT';
exports.SEND_EVENT = SEND_EVENT;

function sendEvent(name, value) {
  return {
    type: SEND_EVENT,
    payload: {
      name: name,
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX0VWRU5UIiwic2VuZEV2ZW50IiwibmFtZSIsInZhbHVlIiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zZW5kRXZlbnQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9FVkVOVCA9ICdXRUJfQ0hBVC9TRU5EX0VWRU5UJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZEV2ZW50KG5hbWUsIHZhbHVlKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VORF9FVkVOVCxcbiAgICBwYXlsb2FkOiB7IG5hbWUsIHZhbHVlIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VORF9FVkVOVCB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsVUFBVSxHQUFHLHFCQUFuQjs7O0FBRWUsU0FBU0MsU0FBVCxDQUFtQkMsSUFBbkIsRUFBeUJDLEtBQXpCLEVBQWdDO0VBQzdDLE9BQU87SUFDTEMsSUFBSSxFQUFFSixVQUREO0lBRUxLLE9BQU8sRUFBRTtNQUFFSCxJQUFJLEVBQUpBLElBQUY7TUFBUUMsS0FBSyxFQUFMQTtJQUFSO0VBRkosQ0FBUDtBQUlEIn0=